import { createSelector } from "@reduxjs/toolkit";
import selectGymsRaw from "./selectGymsRaw";

export default createSelector(selectGymsRaw, ({ gymsList }) => gymsList);
